
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Hooks/useInterval.html",
      function () {
        return require("private-next-pages/Hooks/useInterval.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Hooks/useInterval.html"])
      });
    }
  